import { render } from "./GamificationNews.vue?vue&type=template&id=7dbedee8"
import script from "./GamificationNews.vue?vue&type=script&lang=js"
export * from "./GamificationNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__